import React, { useEffect }  from 'react';
import { DbnpBasicInfoComponent } from './dbnp-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import DbnpRegistriesComponent from './dbnp-registries.component';
import DBNPOrgRegistries from '../containers/dbnp-org-registries';
import { useSearchParams } from 'react-router-dom';
import DBARegistries from '../containers/dbnp-dbas';
import GlobalCatalogInfoComponent from '../containers/global-catalog-info.component';
import DBNAgents from '../containers/dbn-agents';


export const DbnpComponent = ({handlePopulateOrgRegistry,id,countries,subDomains,domains,opsnumber,handleFormChange,selectedDbnpRegistry, handleInnerFormChange,selectedDbnp,organizationUnits,back,handleFormSubmit}: any) => {
    const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
      const [searchParams, setSearchParams] = useSearchParams();
  const tabItems=[
    {
        id:1,
        title:'Basic Info',
        component:<DbnpBasicInfoComponent
        selectedDbnp={selectedDbnp}
        handleInnerFormChange={handleInnerFormChange}
        organizationUnits={organizationUnits}
        handleFormChange={handleFormChange}
        selectedDbnpRegistry={selectedDbnpRegistry}
        opsnumber={opsnumber}
       domains={domains}
       subDomains={subDomains}
       countries={countries}
       id={id}
      />,
    isVisible:true,
    },
    {
      id:2,
      title:'DBNP registry Details',
      component: <DbnpRegistriesComponent
      handleBacicInnerFormChange={handleInnerFormChange}
      handleInnerFormChange ={handleFormChange}
      selectedDbnpRegistry={selectedDbnpRegistry}
      opsnumber={opsnumber}
     domains={domains}
     subDomains={subDomains}
     countries={countries}
     id={id}
/>,
  isVisible:selectedDbnp?.IsEnableDbnpRegistry? true: false,
  },
  {
    id: 3,
    title: 'DBAs',
    component: <DBARegistries selectedDbnp={selectedDbnp} />,
    isVisible: true, 
  },
  {
    id: 4,
    title: 'DBNBIZs',
    component: <DBNPOrgRegistries selectedDbnpRegistry={selectedDbnpRegistry} />,
    isVisible: selectedDbnpRegistry && selectedDbnpRegistry.DBNPId ? true : false, 
  },
  {
    id: 5,
    title: 'DBN Agents',
    component: <DBNAgents selectedDbnpRegistry={selectedDbnpRegistry} />,
    isVisible: selectedDbnpRegistry && selectedDbnpRegistry.DBNPId ? true : false, 
  },
  {
    id: 6,
    title: 'Global Catalog',
    component: <GlobalCatalogInfoComponent selectedDbnp={selectedDbnp} />,
    isVisible: true, 
  },
  ]
    useEffect(() => {
            const tabTitleFromURL = searchParams.get('tab');
            if (tabTitleFromURL) {
                const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
                if (tabIndex !== -1) {
                    setSelectedTabIndex(tabIndex);
                }
            } else {
                setSelectedTabIndex(0);
            }
        }, [searchParams]);
    
        const handleTabChange = (index: number) => {
            setSelectedTabIndex(index);
            setSearchParams({ tab: tabItems[index].title });
        };
    
        if (selectedTabIndex === null) {
            return null;
        }
    
  return (
   <>
       
      
         {/* <div className='flex w-full justify-end items-end'>
      <button
            onClick={handlePopulateOrgRegistry}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Publish to cloud
           </button>
      </div> */}
      <TabContainer tabItems={tabItems}  selectedIndex={selectedTabIndex}
            onChange={handleTabChange} />
   
      <div className='flex w-full justify-end items-end mr-20 '>
        <button
              onClick={back}
              type='button'
              className="m-2 ml-12 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
              type="submit"
          >
            Save
          </button>
        </div>
        </>
  )
}
export default DbnpComponent;
